var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSofa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9V7.0385C5 5.6365 6.1365 4.5 7.5384 4.5h8.9231C17.8635 4.5 19 5.6365 19 7.0385V9h.5c1.6569 0 3 1.3432 3 3v2c0 1.4865-1.0811 2.7205-2.5 2.9586V18.5h-2V17H6v1.5H4v-1.5414C2.5811 16.7205 1.5 15.4865 1.5 14v-2c0-1.6568 1.3432-3 3-3H5zm2-1.9615c0-.2974.241-.5385.5384-.5385h8.9231c.2974 0 .5385.241.5385.5385V11H7V7.0385zM3.5 12c0-.5522.4477-1 1-1H5v2h14v-2h.5c.5523 0 1 .4478 1 1v2c0 .5523-.4477 1-1 1h-15c-.5523 0-1-.4477-1-1v-2z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa);
export default __webpack_public_path__ + "static/media/sofa.fe23ffe63722780f8e8ceb07568c71f6.svg";
export { ForwardRef as ReactComponent };